import React, { useState, useEffect } from 'react';
import '../CSS/Faculty.css';
import FacultyCard from './FacultyCard';
import { getAllFaculty } from '../firebase/firestoreService';

const Faculty = () => {
  const [faculty, setFaculty] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllFaculty()
      .then(data => setFaculty(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="ngt-page-banner">
        <h1>Our Faculty</h1>
        <p>Meet the dedicated educators who make NGT's academic excellence possible</p>
      </div>
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Faculty</li>
        </ol>
      </nav>
      <section style={{ padding: '4rem 0' }}>
        <div className="container">
          <h2 className="section-title">Expert Educators</h2>
          <p className="section-subtitle">30+ experienced professionals committed to student success</p>
          {loading ? (
            <div className="ngt-spinner" aria-label="Loading faculty"></div>
          ) : faculty.length === 0 ? (
            <p className="text-center" style={{ color: 'var(--ngt-grey)' }}>Faculty profiles coming soon.</p>
          ) : (
            <div className="row g-4">
              {faculty.map((f, i) => (
                <div key={f.id || i} className="col-md-6 col-lg-4 col-xl-3">
                  <FacultyCard faculty={f} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Faculty;
